require('./page-footer.scss');

const PageFooterComponent = {
    selector: 'sbPageFooter',
    template: require('./page-footer.html'),
};

export default PageFooterComponent;



// WEBPACK FOOTER //
// ./src/app/components/page-footer/index.js